export const CAMPAIGNS_ROUTE_NAME = '::Menu:Campaigns';

/**
 * Menu entries that are a page AND a group: clicking one opens its page and expands its sub-items.
 *
 * Opt-in on purpose. Other parents (Administration, Identity Management) have no page of their own, so
 * keeping their path as a link would navigate to nothing.
 */
export const NAVIGABLE_PARENT_ROUTE_NAMES: ReadonlySet<string> = new Set([CAMPAIGNS_ROUTE_NAME]);
